import SkeletonLoader from './NoticesAllSkeletonLoader';
import SettingsModal from './SettingsModal';

export { SettingsModal, SkeletonLoader };
